import type { ThemeToken } from '../../store/types';
import { parseDesignMd } from '../designmd';
import { rawUrl } from './index';

type FetchFn = (url: string) => Promise<Response>;

const cache = new Map<string, ThemeToken>();

/** Test-only: reset the in-memory cache. */
export function _clearThemeCache(): void {
  cache.clear();
}

export async function loadThemeFromLibrary(slug: string, fetchFn: FetchFn = fetch): Promise<ThemeToken> {
  const cached = cache.get(slug);
  if (cached) return cached;
  const res = await fetchFn(rawUrl(slug));
  if (!res.ok) throw new Error(`Failed to load "${slug}" (HTTP ${res.status})`);
  const source = await res.text();
  const theme = parseDesignMd(source);
  cache.set(slug, theme);
  return theme;
}
